import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { select } from '@ngxs/store';
import { AnimateModule, UserType, WwwAppState } from '@pro-connect/shared';
import { NgxMaskPipe } from 'ngx-mask';
import { IOrder } from '../../../../models/order';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-order-details-modal',
  templateUrl: './order-details-modal.component.html',
  styleUrls: ['./order-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule, NgxMaskPipe],
})
export class OrderDetailsModalComponent {
  public user = select(WwwAppState.user);
  public order = input.required<IOrder>();
  public UserType = UserType;

  constructor(private readonly _ngbActiveModal: NgbActiveModal) {}

  public closeModal(): void {
    this._ngbActiveModal.close();
  }
}
